import { getNormalizedData } from './getNormalizedData.js';
import { convertToText } from './util/convertToText.js';
/**
 * Get normalized data as text
 * @param spectra - Array of spectrum objects
 * @param options - Options for filtering and formatting
 * @returns Text representation of normalized data
 */
export function getNormalizedText(spectra, options = {}) {
    const { fs = '\t', rs = '\n' } = options;
    return convertToText(getNormalizedData(spectra, options), {
        rs,
        fs,
    });
}
//# sourceMappingURL=getNormalizedText.js.map